import {createSlice, PayloadAction, SliceCaseReducers} from '@reduxjs/toolkit';
import {LoginState} from '../../../../shared/models/login/loginStep';
import {AppActions} from '../../../actions';

export interface RuntimeLoginStepState {
  value: LoginState;
}

const initialState: RuntimeLoginStepState = {
  value: LoginState.enter,
};

export const loginStepSlice = createSlice<RuntimeLoginStepState, SliceCaseReducers<RuntimeLoginStepState>>({
  name: '@@eskmo/runtime/loginStep',
  initialState,
  reducers: {
    setLoginStep: (state, action: PayloadAction<LoginState>) => {
      state.value = action.payload;
    },
  },
  extraReducers: {
    [AppActions.Reset]: () => {
      return initialState;
    },
  },
});

export const loginStep = loginStepSlice.reducer;
